import * as i0 from '@angular/core';
import { inject, TemplateRef, Directive, InjectionToken, forwardRef, model, input, numberAttribute, booleanAttribute, signal, computed, output, contentChild, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
function BarRating_For_3_Case_2_ng_template_0_Template(rf, ctx) {}
function BarRating_For_3_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BarRating_For_3_Case_2_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    let tmp_16_0;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const fractionTemplate_r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_16_0 = ctx_r3.customFractionRating()) == null ? null : tmp_16_0.template) || fractionTemplate_r5);
  }
}
function BarRating_For_3_Case_3_ng_template_0_Template(rf, ctx) {}
function BarRating_For_3_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BarRating_For_3_Case_3_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    let tmp_16_0;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const inactiveTemplate_r6 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_16_0 = ctx_r3.customInActiveRating()) == null ? null : tmp_16_0.template) || inactiveTemplate_r6);
  }
}
function BarRating_For_3_Case_4_ng_template_0_Template(rf, ctx) {}
function BarRating_For_3_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BarRating_For_3_Case_4_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    let tmp_16_0;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const activeTemplate_r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_16_0 = ctx_r3.customActiveRating()) == null ? null : tmp_16_0.template) || activeTemplate_r7);
  }
}
function BarRating_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵlistener("mouseenter", function BarRating_For_3_Template_div_mouseenter_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const value_r3 = i0.ɵɵreadContextLet(0);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.hoveredIndex.set(value_r3));
    });
    i0.ɵɵtemplate(2, BarRating_For_3_Case_2_Template, 1, 1, null, 8)(3, BarRating_For_3_Case_3_Template, 1, 1, null, 8)(4, BarRating_For_3_Case_4_Template, 1, 1, null, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_16_0;
    const unit_r8 = ctx.$implicit;
    const ɵ$index_5_r9 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext();
    const value_r10 = i0.ɵɵstoreLet(ɵ$index_5_r9 + 1);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-value", value_r10);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_16_0 = unit_r8) === ctx_r3.UNITS.fraction ? 2 : tmp_16_0 === ctx_r3.UNITS.inactive ? 3 : 4);
  }
}
function BarRating_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.ratingText());
  }
}
function BarRating_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
}
function BarRating_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
}
function BarRating_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
}
let ActiveRating = /*#__PURE__*/(() => {
  class ActiveRating {
    constructor() {
      this.template = inject(TemplateRef);
    }
    static {
      this.ɵfac = function ActiveRating_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ActiveRating)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ActiveRating,
        selectors: [["", "ratingActive", ""]]
      });
    }
  }
  return ActiveRating;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InactiveRating = /*#__PURE__*/(() => {
  class InactiveRating {
    constructor() {
      this.template = inject(TemplateRef);
    }
    static {
      this.ɵfac = function InactiveRating_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InactiveRating)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InactiveRating,
        selectors: [["", "ratingInactive", ""]]
      });
    }
  }
  return InactiveRating;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FractionRating = /*#__PURE__*/(() => {
  class FractionRating {
    constructor() {
      this.template = inject(TemplateRef);
    }
    static {
      this.ɵfac = function FractionRating_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FractionRating)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FractionRating,
        selectors: [["", "ratingFraction", ""]]
      });
    }
  }
  return FractionRating;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const defaultOptions = {
  theme: 'default',
  maxValue: 5,
  showText: false,
  readonly: false
};
const BAR_RATING_OPTIONS = new InjectionToken('BAR_RATING_OPTIONS', {
  providedIn: 'root',
  factory: () => defaultOptions
});
function provideBarRatingOptions(options) {
  return {
    provide: BAR_RATING_OPTIONS,
    useValue: {
      ...defaultOptions,
      ...options
    }
  };
}

/** This allows support [(ngModel)] and ngControl. */
const RATING_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BarRating),
  multi: true
};
/** This allows control required validation. */
const RATING_VALUE_VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => BarRating),
  multi: true
};
var BarRatingUnitStateEnum = /*#__PURE__*/function (BarRatingUnitStateEnum) {
  BarRatingUnitStateEnum["active"] = "active";
  BarRatingUnitStateEnum["inactive"] = "inactive";
  BarRatingUnitStateEnum["selected"] = "selected";
  BarRatingUnitStateEnum["fraction"] = "fraction";
  return BarRatingUnitStateEnum;
}(BarRatingUnitStateEnum || {});
let BarRating = /*#__PURE__*/(() => {
  class BarRating {
    constructor() {
      this.defaultOptions = inject(BAR_RATING_OPTIONS);
      this.onChange = () => {};
      this.onTouched = () => {};
      this.UNITS = BarRatingUnitStateEnum;
      /** Current rating. Can be a decimal value like 3.14 */
      this.rate = model();
      /** Maximal rating that can be given using this widget. */
      this.max = input(this.defaultOptions.maxValue, {
        transform: numberAttribute
      });
      /** A flag indicating if rating can be updated. */
      this.readonly = input(this.defaultOptions.readonly, {
        transform: booleanAttribute,
        alias: 'readonly'
      });
      /** Set the theme */
      this.theme = input(this.defaultOptions.theme);
      /** Show rating title */
      this.showText = input(this.defaultOptions.showText, {
        transform: booleanAttribute
      });
      /** Replace rate value with a title */
      this.titles = input([]);
      /** A flag indicating if rating is required for form validation. */
      this.required = input(false, {
        transform: booleanAttribute
      });
      this.tabIndex = input(0, {
        transform: numberAttribute
      });
      this.hoveredIndex = signal(null);
      this.contexts = computed(() => {
        const length = this.max();
        const currentRate = this.rate();
        const hovered = this.hoveredIndex();
        return Array.from({
          length
        }, (_, i) => {
          if (hovered) {
            return i + 1 <= hovered ? BarRatingUnitStateEnum.active : BarRatingUnitStateEnum.inactive;
          }
          if (i + 1 <= currentRate) {
            return BarRatingUnitStateEnum.selected;
          }
          if ((i + 1 === Math.round(currentRate) && currentRate % 1) >= 0.5) {
            return BarRatingUnitStateEnum.fraction;
          }
          return BarRatingUnitStateEnum.inactive;
        });
      });
      this.ratingText = computed(() => {
        const value = this.hoveredIndex() || this.rate();
        return this.titles()[value] || value;
      });
      /**
       * A stream that forwards a bar rating click since clicks are not propagated
       */
      this.barClick = output();
      this.customActiveRating = contentChild(ActiveRating);
      this.customInActiveRating = contentChild(InactiveRating);
      this.customFractionRating = contentChild(FractionRating);
    }
    updateRating(value) {
      this.rate.set(value);
      this.onChange(value);
    }
    /**
     * This is the initial value set to the component
     */
    writeValue(value) {
      if (value !== null) {
        this.rate.set(value);
      }
    }
    validate(c) {
      return this.required() && !c.value ? {
        required: true
      } : null;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    handleKeydown(event) {
      if (this.readonly() || this.disabled) return;
      const currentRating = this.rate();
      let newRating = currentRating;
      switch (event.key) {
        case 'ArrowRight':
          newRating = Math.min(currentRating + 1, this.max()); // Increase rating
          event.preventDefault();
          break;
        case 'ArrowLeft':
          newRating = Math.max(currentRating - 1, 1); // Decrease rating
          event.preventDefault();
          break;
        case 'Enter':
        case ' ':
          // Select the current rating (handled in click logic)
          event.preventDefault();
          break;
        default:
          return;
        // Ignore other keys
      }
      if (newRating !== currentRating) {
        this.updateRating(newRating);
        this.barClick.emit(newRating);
        this.hoveredIndex.set(newRating);
      }
    }
    handleClick(event) {
      if (this.readonly() || this.disabled) return;
      const target = event.target;
      const unitElement = target.closest('.br-unit');
      const value = unitElement?.getAttribute('data-value');
      if (value) {
        const rating = parseInt(value, 10);
        this.updateRating(rating);
        this.barClick.emit(rating);
      }
    }
    static {
      this.ɵfac = function BarRating_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BarRating)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BarRating,
        selectors: [["bar-rating"]],
        contentQueries: function BarRating_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.customActiveRating, ActiveRating, 5);
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.customInActiveRating, InactiveRating, 5);
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.customFractionRating, FractionRating, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(3);
          }
        },
        inputs: {
          rate: [1, "rate"],
          max: [1, "max"],
          readonly: [1, "readonly"],
          theme: [1, "theme"],
          showText: [1, "showText"],
          titles: [1, "titles"],
          required: [1, "required"],
          tabIndex: [1, "tabIndex"]
        },
        outputs: {
          rate: "rateChange",
          barClick: "barClick"
        },
        features: [i0.ɵɵProvidersFeature([RATING_VALUE_ACCESSOR, RATING_VALUE_VALIDATOR])],
        decls: 11,
        vars: 9,
        consts: [["fractionTemplate", ""], ["activeTemplate", ""], ["inactiveTemplate", ""], ["role", "button", 3, "focusout", "click", "keydown"], [1, "br-units", 3, "mouseleave"], [1, "br-unit"], [1, "br-text"], [1, "br-unit", 3, "mouseenter"], [3, "ngTemplateOutlet"], [1, "br-unit-inner", "br-fraction"], [1, "br-unit-inner", "br-active"], [1, "br-unit-inner", "br-inactive"]],
        template: function BarRating_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3);
            i0.ɵɵlistener("focusout", function BarRating_Template_div_focusout_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTouched());
            })("click", function BarRating_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClick($event));
            })("keydown", function BarRating_Template_div_keydown_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleKeydown($event));
            });
            i0.ɵɵelementStart(1, "div", 4);
            i0.ɵɵlistener("mouseleave", function BarRating_Template_div_mouseleave_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hoveredIndex.set(0));
            });
            i0.ɵɵrepeaterCreate(2, BarRating_For_3_Template, 5, 3, "div", 5, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, BarRating_Conditional_4_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, BarRating_ng_template_5_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, BarRating_ng_template_7_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(9, BarRating_ng_template_9_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("br br-", ctx.customInActiveRating() ? "" : ctx.theme(), "");
            i0.ɵɵclassProp("br-readonly", ctx.readonly())("br-disabled", ctx.disabled);
            i0.ɵɵattribute("tabindex", ctx.disabled || ctx.readonly() ? -1 : ctx.tabIndex());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.contexts());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showText() ? 4 : -1);
          }
        },
        dependencies: [NgTemplateOutlet],
        styles: ["*[_ngcontent-%COMP%]{box-sizing:border-box}[_nghost-%COMP%]{--_br-font-size: var(--br-font-size, 16px);--_br-gap: var(--br-gap, 0);--_br-active-color: var(--br-active-color, #EDB867);--_br-inactive-color: var(--br-inactive-color, #D2D2D2);--_br-effect-scale: var(--br-effect-scale, 1.5);--_br-effect-duration: var(--br-effect-duration, .4s);--_br-effect-ease: var(--br-effect-ease, ease-out)}.br[_ngcontent-%COMP%]{position:relative}.br-units[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;gap:var(--_br-gap)}.br-unit[_ngcontent-%COMP%]{font-size:var(--_br-font-size);cursor:pointer;-webkit-font-smoothing:antialiased;text-rendering:auto}.br-unit-inner[_ngcontent-%COMP%]{position:relative}.br-readonly[_ngcontent-%COMP%]   .br-unit[_ngcontent-%COMP%], .br-disabled[_ngcontent-%COMP%]   .br-unit[_ngcontent-%COMP%]{cursor:default;pointer-events:none}.br-unit-clone[_ngcontent-%COMP%]{position:absolute;pointer-events:none;transform-origin:center;animation:_ngcontent-%COMP%_scale-fade-out var(--_br-effect-duration) var(--_br-effect-ease)}@keyframes _ngcontent-%COMP%_scale-fade-out{0%{transform:scale(1);opacity:1}to{transform:scale(var(--_br-effect-scale));opacity:0}}"],
        changeDetection: 0
      });
    }
  }
  return BarRating;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BarRatingEffect = /*#__PURE__*/(() => {
  class BarRatingEffect {
    constructor() {
      this.barRating = inject(BarRating, {
        host: true,
        self: true
      });
      // Save the original handleClick method
      const originalHandleClick = this.barRating.handleClick.bind(this.barRating);
      // Override the handleClick method
      this.barRating.handleClick = event => {
        // Call the original handleClick logic
        originalHandleClick(event);
        // Add custom effect logic
        this.handleClickWithEffect(event);
      };
    }
    handleClickWithEffect(event) {
      const target = event.target;
      const unitElement = target.closest('.br-unit');
      const clone = unitElement.cloneNode(true);
      const rect = unitElement.getBoundingClientRect();
      const parentRect = event.currentTarget.getBoundingClientRect();
      clone.classList.add('br-unit-clone');
      clone.style.left = `${rect.left - parentRect.left}px`;
      clone.style.top = `${rect.top - parentRect.top}px`;
      clone.style.width = `${rect.width}px`;
      clone.style.height = `${rect.height}px`;
      const parentElement = event.currentTarget;
      parentElement.appendChild(clone);
      clone.addEventListener('animationend', () => {
        parentElement.removeChild(clone);
      });
    }
    static {
      this.ɵfac = function BarRatingEffect_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BarRatingEffect)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BarRatingEffect,
        selectors: [["bar-rating", "effect", ""]]
      });
    }
  }
  return BarRatingEffect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BarRatingModule = /*#__PURE__*/(() => {
  class BarRatingModule {
    static {
      this.ɵfac = function BarRatingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BarRatingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BarRatingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return BarRatingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ActiveRating, BAR_RATING_OPTIONS, BarRating, BarRatingEffect, BarRatingModule, FractionRating, InactiveRating, provideBarRatingOptions };
